"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackingInfo = void 0;
const core_1 = require("@material-ui/core");
const date_picker_1 = require("client/components/material/date-picker/date-picker");
const select_1 = require("client/components/material/select");
const text_field_1 = require("client/components/material/text-field");
const moment = require("moment");
const React = require("react");
const styles = core_1.createStyles({
    row: {
        "display": "grid",
        "gridTemplateColumns": "150px 150px 115px 200px 200px",
        "gridGap": "1rem",
        "&:not(:last-child)": {
            marginBottom: "1rem"
        }
    },
    trackingField: {
        width: "150px",
        minWidth: "0"
    },
    shippingField: {
        width: "115px",
        minWidth: "0"
    }
});
const decorate = core_1.withStyles(styles);
exports.TrackingInfo = decorate((props) => {
    const { classes, trackingNumber, trackingLink, shippingCost, distributorSelected, expectedDate, onChange, onChangeExpectedDate, onSelect, shouldDisableShippingCost } = props;
    return (React.createElement("div", { className: classes.row },
        React.createElement(text_field_1.MaterialTextField, { className: classes.trackingField, onChange: onChange("trackingNumber"), label: "Tracking #", value: trackingNumber }),
        React.createElement(text_field_1.MaterialTextField, { className: classes.trackingField, onChange: onChange("trackingLink"), label: "Tracking link", value: trackingLink }),
        shouldDisableShippingCost ? (React.createElement(text_field_1.MaterialTextField, { className: classes.shippingField, label: "Shipping cost", value: shippingCost, disabled: shouldDisableShippingCost })) : (React.createElement(text_field_1.MaterialTextField, { className: classes.shippingField, onChange: onChange("shippingCost"), type: "number", numType: "price", label: "Shipping cost", value: shippingCost })),
        React.createElement(select_1.MaterialSelect, { onSelect: onSelect, placeholder: "Select a distributor", label: "Distributor", options: props.distributorOptions, value: distributorSelected }),
        React.createElement(date_picker_1.MaterialDatePicker, { className: "tracking-expected-date", label: "Expected Date", value: expectedDate ? expectedDate.toString() : "", onChange: (value) => {
                if (typeof value === "string") {
                    onChangeExpectedDate(value);
                }
                else {
                    const dateToString = moment(value).format("MM/DD/YYYY");
                    onChangeExpectedDate(dateToString);
                }
            } })));
});



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/inventory-order/tabs/order-review/components/tracking-info/tracking-info.tsx
// module id = 3585
// module chunks = 0